import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Table, Panel, IconButton, Icon, Message, ButtonGroup } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import pathname from '../../constants/pathname'
import { getMultiApproveReviewerList } from '../../redux/actions/multiReview'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'
import DashboradToggle from '../dashboard/DashboradToggle'

export default function MultiApproveReviewerGroup({
  shaded = true,
  bordered = true,
  config,
  onSettingChange = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [error, setError] = useState()
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [schema, setSchema] = useState()

  const [expandedPanel, setExpandedPanel] = useState(true)

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  let history = useHistory()

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handleReload(displayLength, page)
    }
  }, [])

  const handleReload = async (pagesize, pagenumber) => {
    setLoading(true)
    // startLoading()
    try {
      const response = await getMultiApproveReviewerList(pagesize, pagenumber)

      setSchema(response)
    } catch (e) {
      console.log('e', e)
      setError('เกิดข้อผิดพลาดดึงข้อมุลไม่สำเร็จ')
    }
    // doneLoading()
    setLoading(false)
  }

  const onSelected = (data) => {
    console.log('handleAction', data)
    sessionStorage.setItem('projectId', data.id)
    sessionStorage.setItem('param', '')
    history.push(`${pathname.proposal.review.approveReviewerMulti}`)
  }

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    handleReload(dataKey, 1)
  }
  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    handleReload(displayLength, dataKey)
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}

          <Panel
            header={schema.header}
            bordered={bordered}
            collapsible
            defaultExpanded={schema?.values?.length > 0 && expandedPanel}
            shaded={shaded}
            onClick={() => {
              setExpandedPanel(!expandedPanel)
            }}
            style={{ marginTop: 15 }}
          >
            {error && (
              <Message
                closable
                showIcon
                type="error"
                description={error}
                onClose={() => setError()}
              />
            )}

            <Table
              wordWrap
              autoHeight={config && true}
              height={400}
              loading={loading}
              data={schema.values || []}
            >
              <Column width={80} align="center">
                <HeaderCell>
                  <span>ลำดับที่</span>
                </HeaderCell>
                <Cell>
                  {(_, index) => {
                    return index + 1 + (page * displayLength - displayLength)
                  }}
                </Cell>
              </Column>
              <Column width={160} align="center" flexGrow={1}>
                <HeaderCell>
                  <span>วันที่ทำรายการ</span>
                </HeaderCell>
                <Cell dataKey="sendConsiderDate" />
              </Column>
              <Column width={200} align="center" flexGrow={1}>
                <HeaderCell>
                  <span>วิธีการกลั่นกรอง</span>
                </HeaderCell>
                <Cell dataKey="reviewTypeName" />
              </Column>
              <Column width={130} align="center" flexGrow={1}>
                <HeaderCell>
                  <span>จำนวนโครงการ</span>
                </HeaderCell>
                <Cell dataKey="numberOfProject" />
              </Column>
              <Column width={130} align="center" flexGrow={1}>
                <HeaderCell>
                  <span>จำนวนผู้ทรงคุณวุฒิ</span>
                </HeaderCell>
                <Cell dataKey="totalReviewer" />
              </Column>

              <Column width={100} align="center" fixed="right">
                <HeaderCell align="center"></HeaderCell>
                <Cell>
                  {(rowData) => {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon={'eye'} className="bt-gost-icon-radius" />}
                          onClick={() => {
                            onSelected(rowData)
                          }}
                          disabled={config && true}
                        >
                          แสดง
                        </IconButton>
                      </ButtonGroup>
                    )
                  }}
                </Cell>
              </Column>
            </Table>

            <TablePagination
              lengthMenu={defaultLengthMenu}
              activePage={page || defaultPage}
              renderLengthMenu={(lengthMenu) => {
                return (
                  <>
                    {lengthMenu}
                    {`รายการ/หน้า`}
                  </>
                )
              }}
              renderTotal={(total) => {
                return <>{` ทั้งหมด ${total} รายการ`}</>
              }}
              displayLength={displayLength || 5}
              total={schema.totalSize}
              onChangePage={handleChangePage}
              onChangeLength={handleChangeLength}
            />
          </Panel>
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'รายการที่รออนุมัติผู้ทรงคุณวุฒิสำหรับกลั่นกรองทางวิชาการหลายโครงการ',
  totalSize: 1,
  values: [
    {
      sendConsiderDate: 'DD MM YYYY',
      reviewTypeName: 'กระดาษ',
      numberOfProject: 'XXX',
      totalReviewer: 'XXX',
    },
  ],
}
